import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FaQuestionCircle, FaEnvelope, FaPhone, FaClipboardList } from 'react-icons/fa';
import './Inquiry.css';

const Inquiry = () => {
  return (
    <div className="inquiry-page">
      <div className="inquiry-container">
        {/* Header Section */}
        <motion.div 
          className="inquiry-header"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <h1 className="page-title">INQUIRY</h1>
        </motion.div>

        {/* Inquiry Support Section */}
        <motion.div 
          className="construction-section"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          <div className="construction-card">
            <div className="construction-icon">
              <FaQuestionCircle className="icon" />
              <FaEnvelope className="icon" />
              <FaPhone className="icon" />
              <FaClipboardList className="icon" />
            </div>
            
            <h2 className="construction-title">Inquiry Support</h2>
            
            <p className="construction-message">
              For product quotes, pricing, technical support, and custom solutions,
              our team is handling inquiries directly. Reach out through the contact
              form or connect with us by phone and email for a quick response.
            </p>
            
            <div className="construction-features">
              <div className="feature-item">
                <span className="feature-dot"></span>
                <span>Quick Quote Requests</span>
              </div>
              <div className="feature-item">
                <span className="feature-dot"></span>
                <span>Product Information</span>
              </div>
              <div className="feature-item">
                <span className="feature-dot"></span>
                <span>Technical Support</span>
              </div>
              <div className="feature-item">
                <span className="feature-dot"></span>
                <span>Custom Solutions</span>
              </div>
              <div className="feature-item">
                <span className="feature-dot"></span>
                <span>Pricing Inquiries</span>
              </div>
              <div className="feature-item">
                <span className="feature-dot"></span>
                <span>Direct Contact</span>
              </div>
            </div>
            
            <div className="contact-alternative">
              <h3>Need immediate assistance?</h3>
              <p>Please contact us directly through our Contact Us page or call our sales team.</p>
            </div>
            
            <div className="inquiry-actions">
              <Link className="inquiry-action-btn primary" to="/contact#inquiry-form">
                Open Contact Form
              </Link>
              <Link className="inquiry-action-btn secondary" to="/contact">
                View Contact Details
              </Link>
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default Inquiry;
